import { useFormikContext } from 'formik'
import { Autocomplete, TextField, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import useStyles from 'src/components/text-input/styles'

import { countries } from 'src/common/utils'
import { useStyles as useStyles2 } from './styles'
import { ETranslationNs } from 'src/types'

const CountriesFormInput = () => {
  const [t] = useTranslation([ETranslationNs.Common, ETranslationNs.Form])
  const { values, handleChange } = useFormikContext<{ country: string }>()
  const theme = useTheme()
  const classes = useStyles({})
  const classes2 = useStyles2()

  const handleCountryChange = (event: any, value: null | string) => {
    handleChange({
      target: {
        name: 'country',
        value,
      },
    })
  }

  return (
    <Autocomplete
      disablePortal
      autoHighlight
      defaultValue={values.country || undefined}
      options={countries}
      ListboxProps={{ className: classes2.inputList }}
      style={{ height: '100%' }}
      value={values.country}
      fullWidth
      onChange={handleCountryChange}
      renderInput={(props) => (
        <TextField
          {...props}
          autoComplete="off"
          variant="standard"
          className={classes.container}
          style={{ width: '100%' }}
          InputProps={{
            ...props.InputProps,
            disableUnderline: true,
          }}
          inputProps={{
            ...props.inputProps,
            className: classes.input,
          }}
          InputLabelProps={{
            className: classes.label,
            style: {
              color: theme.palette.custom.grey2,
            },
          }}
          size="small"
          label={t('country-input-label.v', { ns: ETranslationNs.Form })}
          placeholder={`${t('text-input-placeholder-prepend.v', { ns: ETranslationNs.Form })} ${t(
            'country-input-placeholder.v',
          )}`}
          id={'country'}
          name={'country'}
          focused
          type="text"
        />
      )}
    />
  )
}

export { CountriesFormInput }
